'use strict';

require('core/productDetail');
var processInclude = require('base:util');

$(document).ready(function () {
    processInclude(require('./product/attributeUpdate'));
    processInclude(require('./product/showMarkingDescription'));
});
